<template>
  <div
    class="w-12/12 lg:w-9/12 calendar-table px-0 static float-left float-print-none"
    :class="{ 'lg:!w-12/12': $isSol || fullWidth }"
  >
    <slot name="aboveFilters" />
    <FilterBar
      :dark-filter="darkFilter"
      :view-mode="viewMode"
      :show-view-mode="showViewMode"
      :show-last-minute="showLastMinute"
      :has-predefined-airport="hasPredefinedAirport"
      @filter="$emit('fetch')"
      @reset-filters="$emit('resetFilters')"
    />
    <slot name="aboveCal" />
    <InfiniteScroll @fetch="$emit('next')">
      <template #content>
        <TripTable
          ref="tripTable"
          class="mt-4"
          :trips="trips"
          :loading="loading"
          :busy="tableBusy"
        />
      </template>
      <template #loading>
        <Loading v-if="trips.length > 0 && !loading && showNext" />
      </template>
    </InfiniteScroll>
    <template v-if="trips.length === 0">
      <Loading v-if="loading || navigationTransitioning" />
      <LazyTooManyFilters
        v-else
        @reset-filters="$emit('resetFilters')"
      />
    </template>
  </div>
</template>

<script>
import events from '@layers/web/constants/events.js'

export default defineNuxtComponent({
  props: {
    viewMode: {
      type: String,
      default: 'list',
    },

    trips: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },

    tableBusy: {
      type: Boolean,
      default: false,
    },

    showNext: {
      type: Boolean,
      default: false,
    },

    showPrevious: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },

    showLastMinute: {
      type: Boolean,
      default: false,
    },

    showViewMode: {
      type: Boolean,
      default: false,
    },

    darkFilter: {
      type: Boolean,
      default: false,
    },

    hasPredefinedAirport: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['resetFilters', 'fetch', 'next'],

  data () {
    return {
      navigationTransitioning: false,
    }
  },

  mounted () {
    this.$event.$on(events.nuxtIsLoading, this.isLoading)
  },

  beforeUnmount () {
    this.$event.$off(events.nuxtIsLoading, this.isLoading)
  },

  methods: {
    isLoading (v) {
      this.navigationTransitioning = v
    },
  },
})
</script>
